
import React from "react";
import { Link } from 'react-router-dom';


function Footer() {
  return (
    <>
       <footer>
        <div className="container">
          <div className="footer-inner">
            <div className="footer-widget">
              <div className="footer-menu">
                <div className="widget-box">
                  <ul>
                    <li><Link as={Link} to="/about">About Library</Link></li>
                    <li><Link as={Link} to="/library-services">Library Services</Link></li>
                    <li><Link as={Link} to="/aska-librarian">Ask a Librarian</Link></li>
                  </ul>
                </div>
                <div className="widget-box">
                  <ul>
                    
                  <li><Link as={Link} to="/event-calendar">Upcoming Events</Link></li>
                    <li><Link as={Link} to="/resource-request">Resource Request Form</Link></li>
                    <li><Link as={Link} to="/frequently-asked-questions">FAQs</Link></li>
                  </ul>
                </div>
              </div>
              <div className="copy-content">
              <div  className="copyright"> 
    <p><a href={"https://habib.edu.pk/"} target="_blank"> Habib University</a>- All Right Reserved<span className="seprator">|</span></p>
    <p>Powered by <a href={"https://habib.edu.pk/huit/"} target="_blank"> HUIT</a></p>
</div>
                <p className="copyright"> <a href={"https://habib.edu.pk/privacy-statement/"} target="_blank"> Privacy Statement</a></p>
              </div>
            </div>
            <div className="footer-right">
              <div className="widget-box">
                <Link to="/" as={Link}>
                  <img src="/library/assets/img/footer-logo.png?v=1.1.1" className="img-fluid" alt=""/>
                </Link>
              </div>
              <ul className="social-links">
                <li>
                  <a href="https://www.facebook.com/HabibUniversity">
                    <img src="/library/assets/img/fa.svg?v=1.1.1" alt=""/> 

                    </a>
                </li>
                <li>
                <a href="https://www.linkedin.com/company/habib-university">
                    <img src="/library/assets/img/li.svg?v=1.1.1" alt=""/> 
                    </a>
                </li>
                <li>
                <a href="https://instagram.com/habibuniversity">
                    <img src="/library/assets/img/in.svg?v=1.1.1" alt=""/> 
                    </a>
                </li>
                <li>
                <a href="https://twitter.com/habibuniversity">
                    <img src="/library/assets/img/tw.svg?v=1.1.1" alt=""/> 
                    </a>
                </li>
                <li>
                <a href="https://www.youtube.com/user/HabibUni">
                    <img src="/library/assets/img/yo.svg?v=1.1.1" alt=""/> 
                    </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
export default Footer;